import * as React from 'react'
import { Responsive, WidthProvider } from 'react-grid-layout'
import { 
  Box,
} from '@mui/material'
import { connect } from "react-redux";

import { setLayout } from '../../slices/visualization';
import GridItem from './GridItem';

const ResponsiveGridLayout = WidthProvider(Responsive);

class Layout extends React.Component {
  handleLayoutChange = (newLayout) => {
      this.props.setLayout({breakpoint: 'lg', layout: newLayout})
  };

  render() {
    const { data, layouts } = this.props;
    return (
      <ResponsiveGridLayout
        className="layout"
        layouts={layouts}
        onLayoutChange={this.handleLayoutChange}
        isDraggable
        isRearrangeable
        isResizable
        draggableHandle=".dashboard-item-title"
        breakpoints={{ lg: 1280 }}
        cols={{ lg: 12 }}
      >
        {Object.keys(data).map((item) => (
          <Box key={item}>
            <GridItem key={item} item={item} {...data[item]} />        
          </Box>
        ))}
      </ResponsiveGridLayout>
    );
  }
}

export default connect(null, {setLayout})(Layout);